export { default } from "./BathroomsIcon";
